import { createLoadFavourites } from './favourites/createLoadFavourites'
import { createLoadFilters } from './filters/createLoadFilters'
import { createSearch } from './search/createSearch'
import { AppContext } from './types/context'
import { SearchService } from './types/services'

export const createServices: (
  context: AppContext,
) => SearchService = context => {
  return {
    search: createSearch(context),
    loadFavourites: createLoadFavourites(context),
    loadFilters: createLoadFilters(context),
  }
}
